/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupArtistsResponseArtistsInnerMembersInner } from './LookupArtistsResponseArtistsInnerMembersInner';
import {
    LookupArtistsResponseArtistsInnerMembersInnerFromJSON,
    LookupArtistsResponseArtistsInnerMembersInnerFromJSONTyped,
    LookupArtistsResponseArtistsInnerMembersInnerToJSON,
} from './LookupArtistsResponseArtistsInnerMembersInner';

/**
 * 
 * @export
 * @interface BulkEditRequestBulkEditChangeArtistsArtistChangeInner
 */
export interface BulkEditRequestBulkEditChangeArtistsArtistChangeInner {
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistChangeInner
     */
    stageName?: string;
    /**
     * 
     * @type {Array<LookupArtistsResponseArtistsInnerMembersInner>}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistChangeInner
     */
    members?: Array<LookupArtistsResponseArtistsInnerMembersInner>;
    /**
     * fa | ofa to link (add/replace); nfa (demote) or null (remove) for delete
     * @type {string}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistChangeInner
     */
    featuredStatus?: BulkEditRequestBulkEditChangeArtistsArtistChangeInnerFeaturedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistChangeInner
     */
    artistId: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistChangeInner
     */
    type?: BulkEditRequestBulkEditChangeArtistsArtistChangeInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditChangeArtistsArtistChangeInner
     */
    op: BulkEditRequestBulkEditChangeArtistsArtistChangeInnerOpEnum;
}


/**
 * @export
 */
export const BulkEditRequestBulkEditChangeArtistsArtistChangeInnerFeaturedStatusEnum = {
    Fa: 'fa',
    Ofa: 'ofa',
    Nfa: 'nfa'
} as const;
export type BulkEditRequestBulkEditChangeArtistsArtistChangeInnerFeaturedStatusEnum = typeof BulkEditRequestBulkEditChangeArtistsArtistChangeInnerFeaturedStatusEnum[keyof typeof BulkEditRequestBulkEditChangeArtistsArtistChangeInnerFeaturedStatusEnum];

/**
 * @export
 */
export const BulkEditRequestBulkEditChangeArtistsArtistChangeInnerTypeEnum = {
    Persona: 'persona',
    Group: 'group'
} as const;
export type BulkEditRequestBulkEditChangeArtistsArtistChangeInnerTypeEnum = typeof BulkEditRequestBulkEditChangeArtistsArtistChangeInnerTypeEnum[keyof typeof BulkEditRequestBulkEditChangeArtistsArtistChangeInnerTypeEnum];

/**
 * @export
 */
export const BulkEditRequestBulkEditChangeArtistsArtistChangeInnerOpEnum = {
    Add: 'add',
    Replace: 'replace',
    Delete: 'delete'
} as const;
export type BulkEditRequestBulkEditChangeArtistsArtistChangeInnerOpEnum = typeof BulkEditRequestBulkEditChangeArtistsArtistChangeInnerOpEnum[keyof typeof BulkEditRequestBulkEditChangeArtistsArtistChangeInnerOpEnum];


/**
 * Check if a given object implements the BulkEditRequestBulkEditChangeArtistsArtistChangeInner interface.
 */
export function instanceOfBulkEditRequestBulkEditChangeArtistsArtistChangeInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "artistId" in value;
    isInstance = isInstance && "op" in value;

    return isInstance;
}

export function BulkEditRequestBulkEditChangeArtistsArtistChangeInnerFromJSON(json: any): BulkEditRequestBulkEditChangeArtistsArtistChangeInner {
    return BulkEditRequestBulkEditChangeArtistsArtistChangeInnerFromJSONTyped(json, false);
}

export function BulkEditRequestBulkEditChangeArtistsArtistChangeInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditRequestBulkEditChangeArtistsArtistChangeInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stageName': !exists(json, 'stageName') ? undefined : json['stageName'],
        'members': !exists(json, 'members') ? undefined : ((json['members'] as Array<any>).map(LookupArtistsResponseArtistsInnerMembersInnerFromJSON)),
        'featuredStatus': !exists(json, 'featuredStatus') ? undefined : json['featuredStatus'],
        'artistId': json['artist_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'op': json['op'],
    };
}

export function BulkEditRequestBulkEditChangeArtistsArtistChangeInnerToJSON(value?: BulkEditRequestBulkEditChangeArtistsArtistChangeInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stageName': value.stageName,
        'members': value.members === undefined ? undefined : ((value.members as Array<any>).map(LookupArtistsResponseArtistsInnerMembersInnerToJSON)),
        'featuredStatus': value.featuredStatus,
        'artist_id': value.artistId,
        'type': value.type,
        'op': value.op,
    };
}

